<template>
  <div class="mb-6 bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-2xl border border-white border-opacity-20 shadow-xl">
    <h2 class="text-2xl font-bold mb-4 text-white flex items-center">
      <span class="bg-gradient-to-r from-yellow-300 to-yellow-400 w-1.5 h-6 rounded-full mr-3"></span>
      Evaluación de Personalidad
    </h2>
    
    <div class="overflow-x-auto">
      <table class="w-full border-collapse bg-white bg-opacity-5 rounded-xl overflow-hidden">
        <thead>
          <tr class="bg-blue-900 bg-opacity-40 text-white border-b border-white border-opacity-20">
            <th class="p-4 text-left font-bold">Aspecto</th>
            <th class="p-4 text-left font-bold">Evaluación</th>
            <th class="p-4 text-left font-bold">Justificación</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index" 
              class="border-b border-white border-opacity-10 text-white text-opacity-90 hover:bg-white hover:bg-opacity-10 transition-colors">
            <td class="p-4 font-medium">{{ item.aspect }}</td>
            <td class="p-4">
              <span class="inline-block px-3 py-1 rounded-full" 
                    :class="getEvaluationClass(item.evaluation)">
                {{ item.evaluation }}
              </span>
            </td>
            <td class="p-4">{{ item.justification }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: { type: Array, required: true }
  },
  methods: {
    getEvaluationClass(evaluation) {
      const normalizedEval = evaluation.toLowerCase();
      
      if (normalizedEval.includes('alto') || 
          normalizedEval.includes('excelente') || 
          normalizedEval.includes('muy bueno') ||
          normalizedEval.includes('fuerte')) {
        return 'bg-green-500 bg-opacity-30 text-green-100';
      }
      
      if (normalizedEval.includes('bajo') || 
          normalizedEval.includes('débil') || 
          normalizedEval.includes('pobre') ||
          normalizedEval.includes('limitado')) {
        return 'bg-red-500 bg-opacity-30 text-red-100';
      }
      
      if (normalizedEval.includes('medio') || 
          normalizedEval.includes('moderado') || 
          normalizedEval.includes('adecuado')) {
        return 'bg-yellow-500 bg-opacity-30 text-yellow-100';
      }
      
      return 'bg-blue-500 bg-opacity-30 text-blue-100';
    }
  }
}
</script>

<style scoped>
.backdrop-blur-sm {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
</style>